import { type FeatureModule } from '@store/features/types';

import { frontChatReducer } from './frontChatSlice';

export const frontChatFeature: FeatureModule = {
  id: 'frontChat',
  name: 'Front Chat',
  dependencies: [],
  reducers: {
    frontChat: frontChatReducer,
  },
  // No persistence needed for visibility state
  // No cross-tab sync needed
};
